import { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { ROUTES } from '@/utils/constants'
import { LanguageSwitcher } from '@/components/common/LanguageSwitcher'
import { useTranslation } from 'react-i18next'
import { useAuthStore } from '@/stores/authStore'

export function Header() {
  const { t } = useTranslation()
  const user = useAuthStore((state) => state.user)
  const isAuthenticated = useAuthStore((state) => state.isAuthenticated)
  const [scrolled, setScrolled] = useState(false)
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false)

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 100)
    }

    window.addEventListener('scroll', handleScroll)
    return () => window.removeEventListener('scroll', handleScroll)
  }, [])

  const handleSmoothScroll = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    if (href.startsWith('#')) {
      e.preventDefault()
      const target = document.querySelector(href)
      if (target) {
        target.scrollIntoView({ behavior: 'smooth', block: 'start' })
        setMobileMenuOpen(false)
      }
    }
  }

  const toggleMobileMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen)
  }

  // Logout на лендинге пока не нужен (есть переход в кабинет)

  const getUserDisplayName = () => {
    if (user?.name) return user.name
    if (user?.first_name) {
      const parts = [user.first_name, user.surname].filter(Boolean)
      if (parts.length > 0) return parts.join(' ')
    }
    if (user?.email) return user.email
    return t('dashboard.user')
  }

  return (
    <header className={`header ${scrolled ? 'scrolled' : ''}`} id="header">
      <div className="container">
        <nav className="nav">
          <Link to="/" className="logo">
            <img 
              src="/icon/android-chrome-192x192.png" 
              alt="EASYA" 
              onError={(e) => {
                const target = e.target as HTMLImageElement
                target.src = '/icon/apple-touch-icon.png'
                target.onerror = () => {
                  target.src = '/icon/favicon-32x32.png'
                }
              }} 
            />
            EASYA
          </Link>
          <button 
            className="mobile-menu-toggle"
            onClick={toggleMobileMenu}
            aria-label="Toggle menu"
          >
            <span className={`hamburger ${mobileMenuOpen ? 'active' : ''}`}>
              <span></span>
              <span></span>
              <span></span>
            </span>
          </button>
          <div className={`nav-links ${mobileMenuOpen ? 'mobile-open' : ''}`}>
            <a href="#features" className="nav-link" onClick={(e) => handleSmoothScroll(e, '#features')}>
              {t('landing.header.features')}
            </a>
            <a href="#how-it-works" className="nav-link" onClick={(e) => handleSmoothScroll(e, '#how-it-works')}>
              {t('landing.header.howItWorks')}
            </a>
            <a href="#pricing" className="nav-link" onClick={(e) => handleSmoothScroll(e, '#pricing')}>
              {t('landing.header.pricing')}
            </a>
            <a href="#team" className="nav-link" onClick={(e) => handleSmoothScroll(e, '#team')}>
              {t('landing.header.team')}
            </a>
            <a href="#news" className="nav-link" onClick={(e) => handleSmoothScroll(e, '#news')}>
              {t('landing.header.news')}
            </a>
            <div className="header-language-switcher">
              <LanguageSwitcher />
            </div>
            {isAuthenticated ? (
              <>
                <span className="header-user-name-only">{getUserDisplayName()}</span>
                <Link to={ROUTES.DASHBOARD} className="btn-secondary" onClick={() => setMobileMenuOpen(false)}>
                  {t('dashboard.personalCabinet')}
                </Link>
              </>
            ) : (
              <>
                <Link to={ROUTES.LOGIN} className="btn-secondary" onClick={() => setMobileMenuOpen(false)}>
                  {t('auth.login')}
                </Link>
                <Link to={ROUTES.REGISTER} className="btn-primary" onClick={() => setMobileMenuOpen(false)}>
                  {t('auth.register')}
                </Link>
              </>
            )}
          </div>
        </nav>
      </div>
    </header>
  )
}
